import Vue from 'vue'
import App from './App.vue'
import router, { addRouterGuard } from './router'
import store from './store'
import initAdvSdk from './plugins/init-adv'
import { i18n } from './utils/register/i18n'
import './utils/register/composition-api'
import './utils/register/create-api'
import './utils/register/directive'
import './utils/wsgenv'
import "mand-mobile/components/_style/global.styl"
import 'mand-mobile/lib/mand-mobile.css'
import "normalize.css"
import '@/assets/styles/common.styl'
import { registerStore } from './utils/store'
import { registerRouter } from './utils/router'
import { updateLangInfo } from './utils/lang'
import { errorReport } from './utils/errorReport'
import { initWsg } from './utils/wsgenv'
import {setOid2Cookie} from "@/utils/setOid2Cookie";
import performanceMonitor from "@/utils/performance";
import { trackEvent } from "@/utils/register/omega";

// 标记框架脚本加载完成
performanceMonitor.mark('frameworkScriptLoaded');

Vue.config.productionTip = false
Vue.use(initAdvSdk)

initWsg()
setOid2Cookie()
registerStore(store)
updateLangInfo()
registerRouter(router)
addRouterGuard()
errorReport()

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
    mounted(): void {
        this.$nextTick(() => {
            performanceMonitor.mark('appMounted');
            trackEvent('tech_credit_outside_sw', {
                event_name: 'tech_page_show'
            })
        });
    },
}).$mount('#app')